<template>
  <path pid="0" d="M23 12a9.5 9.5 0 00-8.94-9h-.56a9.39 9.39 0 00-4.25 1 9.5 9.5 0 00-4.43 12.37l-1.77 5.31A1 1 0 004.32 23l5.31-1.77A9.5 9.5 0 0023 12.5zm-2 .5a7.5 7.5 0 01-10.85 6.71 1 1 0 00-.77-.06l-3.8 1.27 1.27-3.8a1 1 0 00-.06-.77A7.5 7.5 0 0113.5 5h.5a7.47 7.47 0 017 7.05z"/>
</template>
